import { useMutation } from '@tanstack/react-query';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { softDeleteSecurity } from '@dealstack/frontend/shared/dataExchange/services/securities';
import { ERROR_CODES } from '@dealstack/shared/lib/common/errors.ts';

export const useDeleteSecurity = ({ onSuccess }: { onSuccess: () => void }) => {
	const tCapManage = useTranslationCapManage();

	return useMutation({
		mutationFn: (securityId: string) => softDeleteSecurity(securityId),
		onSuccess: () => {
			showToastV2({
				message: tCapManage('toasts.success.security_deleted_successfully'),
			});
			onSuccess();
		},
		onError: (error: { error?: { code?: number; message?: string } }) => {
			if (
				error?.error?.message &&
				error.error.message.includes('Securities are used in MIP')
			) {
				showToastV2({
					message: tCapManage('toasts.error.security_cannot_be_deleted_error'),
					state: 'error',
				});
			} else if (
				error?.error?.code &&
				error.error?.message &&
				error.error.code === ERROR_CODES.PROJECT.CAP.SECURITIES[120314]
			) {
				showToastV2({
					message: tCapManage(
						'toasts.error.security_cannot_be_deleted.exchanged_for_error',
						{
							securityName: error.error.message,
						}
					),
					state: 'error',
				});
			} else {
				showToastV2({
					message: tCapManage('toasts.error.security_deleted_error'),
					state: 'error',
				});
			}
		},
	});
};
